import $ from 'jquery';
import { MindboxCarousel } from './mindbox-carousel';

export class MindboxRelatedRecommendations {

    constructor() {
        this.container = $('[data-mindbox-product="related"]');
    }

    init() {
        if (this.container.length === 0) {
            return;
        }

        let productArticle = this.container.attr('data-product-article');
        let _self = this;
        $.ajax({
            url: '/ajax/action/widget_mindbox_products/get_related_products/',
            data: {
                productArticle: productArticle
            },
            type: 'GET',
            success: function(result) {
                if (result.data.status !== 'ok') {
                    console.log('mindbox box not render');
                    return;
                }

                _self.container.html(result.html);
                MindboxCarousel.init(_self.responsiveOptions());
            }
        });
    }

    responsiveOptions() {
        return {
            0: {
                items: 2,
                dots: true
            },
            481: {
                items: 2,
                dots: true
            },
            768: {
                items: 3,
                nav: true
            },
            992: {
                items: 3,
                nav: true
            },
            1200: {
                items: 5,
                nav: true
            }
        };
    }
}
jQuery(function() {
    new MindboxRelatedRecommendations().init();
});



// WEBPACK FOOTER //
// ./modules/mindbox/mindbox-related-recommendations.js